import { Controller } from "@hotwired/stimulus"

// Alterna a visibilidade de um valor sensível ao clicar.
// Uso: data-controller="secret" + targets "masked" e "plain".
export default class extends Controller {
  static targets = ["masked", "plain"]

  toggle() {
    this.maskedTarget.classList.toggle("hidden")
    this.plainTarget.classList.toggle("hidden")
  }
}
